<template>
	<div class="relative !px-4 !py-16 flex flex-col gap-4 items-center !container mx-auto !max-w-seint">
		<button
			type="button"
			aria-label="Go Back"
			@click="handleBackStep"
			class="inline-flex items-center absolute left-4 top-5 gap-2 text-[11px]/[14px] uppercase font-medium"
		>
			<svg-vue icon="back-arrow" />
			<span>Back</span>
		</button>
		<h1 class="!m-0 !p-0 font-butler-light text-center text-3xl/[38px] font-light">Let’s narrow this down</h1>
		<ul class="!m-0 !p-0 grid grid-cols-2 md:grid-cols-4 gap-x-2 gap-y-4">
			<li v-for="imgObj in sublevelImages" :key="imgObj.sublevel">
				<button
					type="button"
					:aria-label="`Select Sublevel ${imgObj.sublevel}`"
					@click="() => handleNextStep(imgObj.sublevel, imgObj.value)"
					:class="['hover:ring-2 hover:ring-black', isActiveSublevel(imgObj.sublevel) ? 'ring-2 ring-black' : '']"
				>
					<img :src="imgObj.src" :alt="imgObj.alt" class="object-cover w-full h-auto" />
				</button>
			</li>
		</ul>
	</div>
</template>
<script setup>
import { onMounted } from 'vue'

const props = defineProps({
	sublevelImages: {
		type: Array,
		required: true,
	},
	isActiveSublevel: {
		type: Function,
		required: true,
	},
	setSublevelName: {
		type: Function,
		required: true,
	},
	setSublevelId: {
		type: Function,
		required: true,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

onMounted(() => {
	window.scrollTo(0, 0)
})

const handleBackStep = () => props.setStep(1)
const handleNextStep = (selectionName, selectionId) => {
	props.setSublevelName(selectionName)
	props.setSublevelId(selectionId)
	props.setStep(3)
}
</script>
